<ng-container [ngSwitch]="config.elementType">
  <app-text-input
    *ngSwitchCase="elementTypes['text']"
    [config]="config"
    [formControl]="inputControl"
    [styleApplied]="styleApplied"
    [errorMsgNoWrap]="true"
    [showCross]="showCross"
    (clearFormCallback)="clearFormCallbackFn($event)"
    [showErrorBorder]="showErrorBorder"
    [placeholder]="placeholder"
    [elementKey]="elementKey"
    >
  </app-text-input>

  <app-text-input
    *ngSwitchCase="elementTypes['number']"
    [config]="config" type="number"
    [formControl]="inputControl"
    [etsMandate]="etsMandate"
    [styleApplied]="styleApplied"
    [errorMsgNoWrap]="true"
    >
  </app-text-input>

 <app-number-input
    *ngSwitchCase="elementTypes['incrementor']"
    [config]="config"
    [label]="config.displayName"
    [formControl]="inputControl"></app-number-input>

  <app-toggle-button
    *ngSwitchCase="elementTypes['toggle']"
    [formControl]="inputControl">
  </app-toggle-button>
  
  <app-multiselect
    *ngSwitchCase="elementTypes['multiSelect']"
    [width]="'150px'" [dropdownListWidth]="'181px'"
    [formControl]="inputControl"
    [options]="config.values"
    [label]="config.visibility.elementKey"
  >
  </app-multiselect>
  
  <app-radio-group
    *ngSwitchCase="elementTypes['radio']"
    [formControl]="inputControl"
    [options]="config.values">
  </app-radio-group>

  <app-time-picker
    *ngSwitchCase="elementTypes['timepicker']"
    [showClear]="!config.mandatory"
    [formControl]="inputControl">
  </app-time-picker>

  <app-date-time-picker
    *ngSwitchCase="elementTypes['datetimepicker']"
    [formControl]="inputControl">
  </app-date-time-picker>
   <app-select
    [showClear]="!config.mandatory"
    *ngSwitchCase="elementTypes['dropdown']"
    [config]="config" type="dropdown"
    [formControl]="inputControl"
    [options]="config.values"
    [itemSizeForCdk]="20"
    [selectStyleApplied]="selectStyleApplied"
    [styleApplied]="styleApplied"
    [customStyle]="customStyle">
  </app-select>
  <!-- config.displayName=='Requester' ? riderOptions : config.values -->
  <app-select
    [showClear]="!config.mandatory"
    *ngSwitchCase="elementTypes['dropdownAndInput']"
    [config]="config" type="dropdownAndInput"
    [formControl]="inputControl"
    [itemSizeForCdk]="20"
    [options]="config.values"
    [selectStyleApplied]="selectStyleApplied">
  </app-select>

  <app-select
    [showClear]="!config.mandatory"
    *ngSwitchCase="elementTypes['dropdownAndSearch']"
    [config]="config" type="dropdownAndSearch"
    [formControl]="inputControl"
    [itemSizeForCdk]="20"
    [options]="elementKey=='costCenter' ? costCenterNames : (elementKey == 'businessUnit' || elementKey == 'department') ? departmentListName : config.values" 
    [selectStyleApplied]="selectStyleApplied">
  </app-select>

  <app-select
    [showClear]="!config.mandatory"
    *ngSwitchCase="elementTypes['dropdownAndSearchAndInput']"
    [config]="config" type="dropdownAndSearchAndInput"
    [formControl]="inputControl"
    [itemSizeForCdk]="20"
    [options]="config.values"
    [selectStyleApplied]="selectStyleApplied"
  ></app-select>

  <app-date-picker
    *ngSwitchCase="elementTypes['datepicker']"
    [config]="config"
    [formControl]="inputControl">
  </app-date-picker>

  <app-location-search
    [showClear]="!config.mandatory"
    *ngSwitchCase="elementTypes['googleAddress']"
    [config]="config"
    [formControl]="inputControl"
    type="googleAddress"
    [getLocationLabel]="getLocationLabel"
    [city]="city"
    [showSavedLocationOnly]="showSavedLocationOnly"
    [savedLocations]="savedLocations"
    [styleApplied]="styleApplied"
    >
  </app-location-search>

  <app-location-search
    [showClear]="!config.mandatory"
    *ngSwitchCase="elementTypes['googleAddressAndInput']"
    [config]="config"
    [formControl]="inputControl"
    type="googleAddressAndInput"
    [getLocationLabel]="getLocationLabel"
    [city]="city"
    [showSavedLocationOnly]="showSavedLocationOnly"
    [savedLocations]="savedLocations"
    [styleApplied]="styleApplied">
  </app-location-search>

</ng-container>
